import { booleanParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
import { playerIdNameParser } from './utils/playerInboundUtils';
function activeContactsParser(str) {
    const allCategoriesString = splitWithBraces(trimBraces(str));
    return allCategoriesString.reduce((acc, categoryString) => {
        if (!categoryString) {
            return acc;
        }
        const categoryParts = splitWithBraces(trimBraces(categoryString));
        const type = categoryParts[0];
        const activeContactsString = categoryParts[1];
        splitWithBraces(trimBraces(activeContactsString)).forEach((friendString) => {
            const activeContactParts = splitWithBraces(trimBraces(friendString));
            const idNameString = activeContactParts[0];
            const idleString = activeContactParts[1];
            const { id, name } = playerIdNameParser(idNameString);
            const activeContact = { activeContactType: type, playerId: id, username: name, idleString };
            acc[type] = acc[type] || [];
            acc[type]?.push(activeContact);
        });
        return acc;
    }, {});
}
export const SET_ACTIVE_CONTACTS_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'showRefreshButton', parser: booleanParser },
        { name: 'activeContacts', parser: activeContactsParser }
    ]
};
